<mat-dialog-content>

    <div class="flex-row flex-space-between">
        <div>
            <mat-card-header class="p-0">
                <mat-card-title>
                    <h3 class="m-0">Upload Frequency</h3>
                    @if (data && user) {
                        <mat-card-subtitle> {{ user | nameDisplay }}'s upload frequency
                            for {{ data?.permission | nameDisplay }}
                        </mat-card-subtitle>
                    }
                </mat-card-title>
            </mat-card-header>
        </div>
        <div class="float-end">
            <button (click)="this.dialogRef.close();" (keyup.enter)="this.dialogRef.close();" class="mat-dialog-close"
                    mat-dialog-close mat-icon-button
                    matTooltip="Close Window">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
    <form [formGroup]="sessionForm" class="rowTwo">
        <mat-form-field appearance="outline" color="primary">
            <mat-label>Period</mat-label>
            <mat-select formControlName="period">
                <mat-option [value]="'weekly'">Weekly</mat-option>
                <mat-option [value]="'monthly'">Every month</mat-option>
                <mat-option [value]="'quarterly'">Four times a year</mat-option>
                <mat-option [value]="'bi-annually'">Twice a year</mat-option>
                <mat-option [value]="'annually'">Once a year</mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" color="primary">
            <mat-label>Start Date</mat-label>
            <input [matDatepicker]="picker" formControlName="start_date" matInput>
            <mat-datepicker-toggle [for]="picker" matIconSuffix></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            @if (sessionForm.controls['start_date'].hasError('matDatepickerParse')) {
                <mat-error>
                    Invalid date format. Please use DD/MM/YYYY.
                </mat-error>
            }
        </mat-form-field>
        <mat-form-field appearance="outline" color="primary">
            <mat-label>Photo Upload Limit</mat-label>
            <input formControlName="image_limit_default" matInput min="0" type="number">
            @if (sessionForm.controls['image_limit_default'].hasError('required')) {
                <mat-error>
                    This field is required
                </mat-error>
            }
            @if (sessionForm.controls['image_limit_default'].hasError('min')) {
                <mat-error>
                    Cannot have negative upload limits
                </mat-error>
            }
        </mat-form-field>
        <mat-form-field appearance="outline" color="primary">
            <mat-label>Video Upload Limit</mat-label>
            <input formControlName="video_limit_default" matInput min="0" type="number">
            @if (sessionForm.controls['video_limit_default'].hasError('required')) {
                <mat-error>
                    This field is required
                </mat-error>
            }
            @if (sessionForm.controls['video_limit_default'].hasError('min')) {
                <mat-error>
                    Cannot have negative upload limits
                </mat-error>
            }
        </mat-form-field>
        <mat-form-field appearance="outline" color="primary">
            <mat-label>Audio Upload Limit</mat-label>
            <input formControlName="audio_limit_default" matInput min="0" type="number">
            @if (sessionForm.controls['audio_limit_default'].hasError('required')) {
                <mat-error>
                    This field is required
                </mat-error>
            }
            @if (sessionForm.controls['audio_limit_default'].hasError('min')) {
                <mat-error>
                    Cannot have negative upload limits
                </mat-error>
            }
        </mat-form-field>
        <mat-form-field appearance="outline" color="primary">
            <mat-label>Document Upload Limit</mat-label>
            <input formControlName="document_limit_default" matInput min="0" type="number">
            @if (sessionForm.controls['document_limit_default'].hasError('required')) {
                <mat-error>
                    This field is required
                </mat-error>
            }
            @if (sessionForm.controls['document_limit_default'].hasError('min')) {
                <mat-error>
                    Cannot have negative upload limits
                </mat-error>
            }
        </mat-form-field>
        <mat-form-field appearance="outline" color="primary">
            <mat-label>Message Upload Limit</mat-label>
            <input formControlName="message_limit_default" matInput min="0" type="number">
            @if (sessionForm.controls['message_limit_default'].hasError('required')) {
                <mat-error>
                    This field is required
                </mat-error>
            }
            @if (sessionForm.controls['message_limit_default'].hasError('min')) {
                <mat-error>
                    Cannot have negative upload limits
                </mat-error>
            }
        </mat-form-field>
    </form>

</mat-dialog-content>
<mat-dialog-actions class="flex-space-around">
    <button (click)="this.dialogRef.close();" (keyup.enter)="this.dialogRef.close();" [disabled]="loading" color="warn"
            mat-dialog-close
            mat-raised-button>
        Cancel
        @if (loading) {
            <mat-icon>
                <mat-spinner color="accent"></mat-spinner>
            </mat-icon>
        }
    </button>
    @if (this.patch) {
        <button (click)="deleteSession()" (keyup.enter)="deleteSession()" [disabled]="loading" color="warn"
                mat-raised-button>
            Delete
            @if (loading) {
                <mat-icon>
                    <mat-spinner color="accent"></mat-spinner>
                </mat-icon>
            }
        </button>
    }
    <button (click)="saveSession()" (keyup.enter)="saveSession()" [disabled]="this.sessionForm.invalid || loading"
            color="primary"
            mat-raised-button>
        Save
        @if (loading) {
            <mat-icon>
                <mat-spinner color="accent"></mat-spinner>
            </mat-icon>
        }
    </button>
</mat-dialog-actions>

